import { withInstall } from '../../../utils/with-install'
import LabelMarker from './LabelMarker.vue'

export const ElAmapLabelMarker = withInstall(LabelMarker)
export default ElAmapLabelMarker
